import { ReportConfig } from '../../dtos/interfaces/report-config';
import { AnytimeAccessPatronLoginAttemptsReportRowDto } from '../../../services/dtos/reports/anytime-access/anytime-access-patron-login-attempts-report-row.dto';
import moment = require('moment');

function toRecord(d: AnytimeAccessPatronLoginAttemptsReportRowDto): AnytimeAccessPatronLoginAttemptsReportRowDto {
    const r = new AnytimeAccessPatronLoginAttemptsReportRowDto();
    r.subjectId    = d.subjectId;
    r.deviceName   = d.deviceName;
    r.datestampUtc = moment.utc(d.timestampUtc).local().format('YYYY-MM-DD');
    r.dayOfWeek    = moment.utc(d.timestampUtc).local().format('dddd');
    r.timestampUtc = moment.utc(d.timestampUtc).local().format('h:mm a');
    r.success = d.success == null
        ? d.success
        : (d.success == '1' ? 'Successful Login' : 'Unsuccessful Login');
    return r;
}

export const patronLoginAttemptsReport: ReportConfig = {
    id: 'anytime-access-patron-login-attempts',
    label: 'Patron Login Attempts',
    category: 'Anytime Access',
    showHeader: true,
    columns: [
        { key: 'datestampUtc', label: 'Date',   width: '12.5%'  },
        { key: 'dayOfWeek',    label: 'Day',    width: '12.5%'  },
        { key: 'timestampUtc', label: 'Time',   width: '12.5%'  },
        { key: 'subjectId',    label: 'ID',     width: '25%'    },
        { key: 'success',      label: 'Result', width: '16.67%' },
        { key: 'deviceName',   label: 'Device', width: '20.83%' },
    ],
    endpoint: 'anytime-access-patron-login-attempts-report',
    mapRows: (rows, search) => rows.map(toRecord),
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/reports/definitions/anytime-access/patron-login-attempts.report.ts